import Group from 'components/utils/Group'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { FormattedMessage } from 'react-intl'
import MarkdownRender from 'LuxKit/MarkdownRender'
import List from 'components/Common/List'
import styled from 'styled-components'
import { rem } from 'polished'
import InclusionsSection from 'components/OfferPage/FlashHotel/InclusionsSection'
import RenderInclusions from 'components/OfferPage/AlwaysOn/RenderInclusions'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL } from 'constants/offer'

interface Props {
  offer: App.HotelOffer | App.BundledOffer
  inclusions: Array<App.PackageInclusion>
  bonusInclusions: Array<App.PackageInclusion>
  amenities: Array<App.PackageRoomAmenity>
  pkg: App.HotelPackage
  roomPolicyDescription?: string
}

const Stack = styled.div`
  & > * + * {
    margin-top: ${rem(8)}
  }

  &.md {
    & > * + * {
      margin-top: ${rem(12)}
    }
  }
`

export default function BundleAndSaveHotelTileInclusionsModalView({
  offer,
  inclusions,
  bonusInclusions,
  amenities,
  pkg,
  roomPolicyDescription,
}: Props) {
  return (
    <Modal title={pkg.roomType.name}>
      <Group
        fullWidth
        direction="vertical"
        horizontalAlign="stretch"
        verticalAlign="start"
        gap={24}
      >
        <BodyText variant="medium">{pkg.roomType.description}</BodyText>
        <Group direction="vertical" gap={8}>
          <Heading variant="heading6">
            <FormattedMessage
              id="5o-kaCp2LuLrZh3isHj2"
              defaultMessage="Package inclusions:"
              description="Heading for package inclusions section in the offer inclusions section"
            />
          </Heading>
          <Stack className="md">
            {offer.type === OFFER_TYPE_ALWAYS_ON && (
              <RenderInclusions
                bonusInclusions={bonusInclusions}
                inclusions={inclusions}
              />)}
            {offer.type === OFFER_TYPE_HOTEL && (<InclusionsSection inclusions={inclusions} bonusInclusions={bonusInclusions} />)}
          </Stack>
          {!!amenities.length && <>
            <Heading variant="heading6">
              <FormattedMessage
                id="frOlP5TM3Aby7ldv-r01"
                defaultMessage="Facilities:"
                description="Section heading for the facilities section on the offer detail page"
              />
            </Heading>
            <Stack className="md">
              <List>
                {amenities.map(amenity =>
                  <li key={amenity.id}>{amenity.description}</li>,
                )}
              </List>
            </Stack>
          </>}
          {!!roomPolicyDescription && <>
            <Heading variant="heading6">
              <FormattedMessage
                id="hZeb5fW3bDlUkFAmeXgg"
                defaultMessage="Room policies:"
                description="Heading for room policies section on the hotel or room booking page"
              />
            </Heading>
            <MarkdownRender fontSize="medium" type="compact" content={roomPolicyDescription} />
          </>}
        </Group>
      </Group>
    </Modal>
  )
}
